import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports, StaffReportsEmployeesService, toastr) => {
			$scope.status = STATUSES.UNLOADED;
			$scope.moment = moment;

			$scope.dataTable = null;

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              // .withHttpConfig({ cache: true})
				              .get()
				              .then((data) => {
					              $scope.dataTable = DataTablesService.configure({
						              id:    $scope.reportId,
						              title: 'Support Worker Unprocessed Visits Report',
					              }, {
						              order: [
							              [
								              6,
								              'asc',
							              ],
							              [
								              0,
								              'asc',
							              ],
							              [
								              1,
								              'asc',
							              ],
						              ],
					              });

					              $scope.data  = data.map((visit) => {
						              return {
							              ...visit,
							              'Duration':  parseInt(visit['Duration']),
							              'KMs':       parseFloat(visit['KMs']),
							              'Travel':    parseFloat(visit['Travel']),
							              'Processed': false,
						              };
					              });
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.processSelected = () => {
				if ($scope.status === STATUSES.LOADED) {
					const visits = $scope.data.filter((item) => {
						return item['Processed'] === true;
					});

					if (visits.length > 0) {
						const promises = visits.map((visit) => {
							return StaffReportsEmployeesService.markOneVisitAsProcessed(visit['Visit Id']);
						});

						Promise.all(promises)
						       .then(function () {
							       toastr.clear();
							       toastr.success('The visits were successfully processed.', 'Success');

							       $scope.refresh();
						       })
						       .catch((error) => {
							       toastr.clear();
							       toastr.error('There was an error while processing the visits, please try again.', 'Error');

							       $scope.refresh();
						       });
					}
				}
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/E973FAE9-EBC2-41CE-BBD7-53B67C13B88D/index.js